export default function() {
    // init select all checkboxes
    $.each($('input[type="checkbox"][value="all"]'), function() {
        var $selector = $(this),
            targets = $selector.attr('name'),
            itemClick = false;

        // trigger change events on targets of the select all element
        $selector.on('change', function() {
            if (!itemClick) {
                // trigger click events on the input fields which need it
                if ($selector.is(':checked')) {
                    $('input[name="' + targets + '"]:not(:checked)')
                        .trigger('click');
                } else {
                    $('input[name="' + targets + '"]:checked')
                        .trigger('click');
                }
            }
        });

        // listen for change events on the targets to de/activate the select all element
        $('input[name="' + targets + '"]').on('change', function() {
            itemClick = true;

            var doUnselect = $('input[name="' + targets + '"][value!="all"]')
                                .not(':checked').length;

            // check if all targets are selected
            if (doUnselect) {
                if ($selector.is(':checked')) {
                    $selector.trigger('click');
                }
            } else {
                if ($selector.not(':checked')) {
                    $selector.trigger('click');
                }
            }

            itemClick = false;
        });
    });
}



// WEBPACK FOOTER //
// ./node_modules/@spinnwerk/form-helper/select-all.js